module.exports = __webpack_public_path__ + "img/cartaz.7a6e9b7d.jpg";